export default __webpack_public_path__ + "static/media/Adele 9781408315903.fccf13e5.jpg";